import { useState } from "react";
import { CalendarHeart } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { isGuest } from "@/lib/guest";
import { EventPicker, applyEvent } from "./EventPicker";

export const eventLabel = (it) => [it.event_category, it.event && it.event !== "Birthday" || !it.event_category ? it.event : null].filter(Boolean).join(" · ");

// Lightbox: set this photo's event (owner or admin)
export const EventButton = ({ it, onChanged }) => {
  const [open, setOpen] = useState(false);
  if (isGuest() || !it.can_delete) return null;
  const pick = async (category, event, person) => {
    setOpen(false);
    try {
      const r = await applyEvent([it.id], category, event, person);
      onChanged?.(r.item);
      toast.success(person ? `Event set · added to ${person.name}'s Birthday Book` : `Event: ${[category, event].filter(Boolean).join(" · ")}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="relative">
      <button className="lb-btn" onClick={() => setOpen(!open)} title="Set event" aria-label="Set event" data-testid="lightbox-event-button"><CalendarHeart size={18} /></button>
      {open && <div className="lb-menu event-menu" data-testid="lightbox-event-menu"><EventPicker onPick={pick} testid="lightbox-event" /></div>}
    </div>
  );
};
